import { render } from "./InspectionSettlementComplete.vue?vue&type=template&id=37fc6404"
import script from "./InspectionSettlementComplete.vue?vue&type=script&lang=js"
export * from "./InspectionSettlementComplete.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__